import React, { Fragment } from "react";
import { TableTabs } from "../../../shared/components";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../components/table/components";
import { Mobile } from "../../../../../../hocs/Responsive";

export const InfectedDevicesTableHeader = () => {
  return (
    <Fragment>
      <TableTabs />
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>
    </Fragment>
  );
};
